export const generateInvitationId = () => {
  const random = Math.random().toString(36).substring(2, 8).toUpperCase();
  return `INVT-${Date.now().toString().slice(-6)}${random}`;
};

export const generateShortCode = () => {
  return Math.random().toString(36).substring(2, 6);
};

export const validateInvitationData = (data) => {
  const errors = {};
  if (!data.invitationDetails?.title?.trim())
    errors.title = "Invitation title is required";
  if (!data.invitationDetails?.eventDate)
    errors.eventDate = "Event date is required";
  if (!data.invitationDetails?.brideName?.trim())
    errors.brideName = "Bride name is required";
  if (!data.invitationDetails?.groomName?.trim())
    errors.groomName = "Groom name is required";
  return errors;
};

export const getInvitationStatusDisplay = (status) => {
  const map = {
    draft: { label: "Draft", color: "default" },
    published: { label: "Published", color: "success" },
    archived: { label: "Archived", color: "warning" },
  };
  return map[status] || { label: status, color: "default" };
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "N/A";
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
};

export const buildInvitationUrl = (baseUrl, invitationId) => {
  return `${baseUrl}/i/${invitationId}`;
};

export const buildShortUrl = (baseUrl, shortCode) => {
  return `${baseUrl}/i/${shortCode}`;
};

export const buildWhatsappShareLink = (message, url) => {
  const text = encodeURIComponent(`${message} ${url}`);
  return `https://wa.me/?text=${text}`;
};
